module.exports = __webpack_public_path__ + "static/img/sup_logo_3.496b44fb.png";